import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import Access from './Access'
import { setMessageCode } from '../../dataStore/actions/room/room'
import setupActions from '../../dataStore/actions/setup'
import { selectors, actions } from '@bt-react/store'
import selectPresentReady from '../../dataStore/selectors/selectPresentReady'
import { State } from '../../dataStore/reducers/reducerType'
import selectHasWebcastData from '../../dataStore/selectors/selectHasWebcastData'
import selectHasUserSettings from '../../dataStore/selectors/selectHasUserSettings'
import selectHasValidUser from '../../dataStore/selectors/selectHasValidUser'
import selectHasGigEnded from '../../dataStore/selectors/selectHasGigEnded'
import selectHasTwilioRoom from '../../dataStore/selectors/selectHasTwilioRoom'
import selectHasTwilioDocs from '../../dataStore/selectors/selectHasTwilioDocs'
import selectHasUserChannelAccess from '../../dataStore/selectors/selectHasUserChannelAccess'
import { fetchSettings } from '../../dataStore/slices/userSettings/userSettingsSlice'

const mapStateToProps = (state: State, props) => ({
  ...props,
  channelId: state.config.channelId,
  webcastId: state.config.webcastId,
  date: selectors.selectWebcast(state, `${state.config.channelId}${state.config.webcastId}`)['start'],
  isPresentReady: selectPresentReady(state),
  messageCode: state.ui.messageCode,
  defaultRole: state.config.gigOptions.role,
  isFetchingUserData: state.user.status.isFetching,
  errorResponse: state.user.status.errorResponse,
  username: state.config.username,
  hasWebcastData: selectHasWebcastData(state),
  hasValidUser: selectHasValidUser(state),
  hasGigEnded: selectHasGigEnded(state),
  hasRoom: selectHasTwilioRoom(state),
  hasDocs: selectHasTwilioDocs(state),
  hasChannelAccess: selectHasUserChannelAccess(state),
  roomname: state.config.roomname,
  hasUserSettings: selectHasUserSettings(state),
  userIsPasswordlessLogin: state.user.data?.preAuth
})

const mapDispatchToProps = dispatch => ({
  setAvailableDevices: () => dispatch(setupActions.setAvailableDevices()),
  setRoomname: roomname => dispatch(setupActions.setRoomname(roomname)),
  setRole: role => dispatch(setupActions.setRole(role)),
  fetchChannelData: (channelId) => dispatch(actions.fetchChannelData(channelId)),
  fetchPublicWebcastData: (channelId, webcastId) => dispatch(actions.fetchPublicWebcastData(channelId, webcastId)),
  fetchUserData: () => dispatch(actions.user.fetchUserData()),
  setMessageCode: code => dispatch(setMessageCode(code)),
  fetchUserSettings: () => dispatch(fetchSettings())
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Access))
